export default {"src":"//jsak.mmtcdn.com/tripmoney/apps/v2/landing-pages/_next/static/media/oneWayArrGrey.204b84aa.svg","height":15,"width":22};